import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const operatorConfigEdit = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.OPERATOR_CONFIG_CITY:
      return { ...state, selectedCity: action.value };
    case actions.OPERATOR_CONFIG_EDIT:
      return { ...state, operatorConfig: action.value };
    case actions.FETCH_OPERATOR_CONFIG:
      return { ...state, operatorConfigData: action.value };
    default:
      return state;
  }
};

export default operatorConfigEdit;

